import lumberYard from "../../buildings/campus/LumberYard";
import {
  registerTransformation,
  TransformationType,
} from "../../calculation/Calculation";
import { TransformationTags } from "../../calculation/TransformationTags";
import { PlayerContextState } from "../../PlayerContext";
import { Resource } from "../../Resources";
import { Upgrade } from "../Upgrade";

class ReinforcedLumberYards extends Upgrade {
  getName(): string {
    return "Reinforced Lumber Yards";
  }

  getMonstiumCost(): number {
    return 350;
  }

  getDisplayDescription(state: PlayerContextState): string {
    return "Increase the effectivity of the blades in your Lumber Yards, making them work faster.";
  }

  getDisplayEffect(state: PlayerContextState): string {
    return "2x:wood: production from Lumber Yards";
  }

  getUpgradeRequirements() {
    return [];
  }
}

const reinforcedLumberYards = new ReinforcedLumberYards();

registerTransformation(
  [[Resource.Wood, lumberYard.getName(), TransformationTags.Production]],
  "ReinforcedLumberYards",
  TransformationType.Multiplier,
  (state) => (reinforcedLumberYards.isPurchased(state) ? 2.0 : 1.0),
);

export default reinforcedLumberYards;
